var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcDone32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M23.669 10.257a1 1 0 0 1 .074 1.412l-9 10a1 1 0 0 1-1.45.038l-5-5a1 1 0 1 1 1.414-1.414l4.255 4.255 8.295-9.217a1 1 0 0 1 1.412-.074",
  clipRule: "evenodd"
})));
export default SvgIcDone32;